<template>
    <div id="app" part="dw-account-box">
        <template v-if="mode === 'bs-3'">
            <Form v-if="showForm" v-on:accountCreated="accountCreated"/>
            <Confirm v-if="showConfirm" v-on:accountConfirmed="accountConfirmed"></Confirm>
            <Organization v-if="showCreateOrganization" v-on:organizationCreated="organizationCreated"></Organization>
        </template>
        <template v-else>
            <Bs4Form v-if="showForm" v-on:accountCreated="accountCreated"/>
            <Bs4Confirm v-if="showConfirm" v-on:accountConfirmed="accountConfirmed"></Bs4Confirm>
            <Bs4Organization v-if="showCreateOrganization"
                             v-on:organizationCreated="organizationCreated"></Bs4Organization>
        </template>
        <div v-if="!showForm && !showConfirm && !showCreateOrganization">
            Uw account is aangemaakt.
        </div>
    </div>
</template>

<script>
  import Form from './components/Form.vue'
  import Bs4Form from './components-bs4/Form.vue'
  import Confirm from './components/Confirm.vue'
  import Bs4Confirm from './components-bs4/Confirm.vue'
  import Organization from './components/Organization.vue'
  import Bs4Organization from './components-bs4/Organization.vue'
  import Vuelidate from 'vuelidate'
  import Vue from 'vue'
  import axios from './axios'
  import store from './store'

  Vue.use(Vuelidate)

  Vue.prototype.$http = axios
  Vue.prototype.$store = store

  export default {
    name: 'App',
    components: {
      Form, Confirm, Organization, Bs4Form, Bs4Confirm, Bs4Organization
    },
    props: {
      mode: {
        type: String,
        default: 'bs-4'
      }
    },
    data () {
      return {
        showForm: true,
        showConfirm: false,
        showCreateOrganization: false,
      }
    },
    created () {
      if (this.$store.state.userId !== null) {
        this.accountCreated()
      }
      if (this.$store.state.confirmed) {
        this.accountConfirmed()
      }
    },
    methods: {
      accountCreated () {
        this.showForm = false
        this.showCreateOrganization = false
        this.showConfirm = true
      },
      accountConfirmed () {
        this.showForm = false
        this.showConfirm = false
        this.showCreateOrganization = true
      },
      organizationCreated () {
        this.showForm = false
        this.showConfirm = false
        this.showCreateOrganization = false
        window.setTimeout(() => {

          document.location.href = '/nl/signup/wizard/finish?token=' + this.$store.state.accessToken + '&organizationId=' + this.$store.state.organizationId
        }, 1000)

      }
    }
  }
</script>

<style lang="scss">
    /*@import 'https://cdn.qr-kassa.nl/67262588/css/bootstrap.css';*/
    /*@import 'https://cdn.qr-kassa.nl/static-assets/css/site.css';*/
    @import 'https://use.fontawesome.com/releases/v5.8.2/css/all.css';

    @import "https://www.digiwallet.nl/bootstrap/css/bootstrap.min.css";
    @import "https://www.digiwallet.nl/css/main.min.css";
    @import "https://www.digiwallet.nl/css/custom.css";
    @import "https://www.digiwallet.nl/css/dashboard.min.css";
    @import "https://www.digiwallet.nl/css/main-front.css";

    body {
        padding-top: 0;
        padding-bottom: 0;
        min-height: auto;
    }

    #app,
    .form-control {
        font-size: 14px !important;
    }

    .form-control {
        height: 33px;
    }

    .loader {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        position: relative;
        margin: 12px auto 0;
    }


    #loader-1:before, #loader-1:after {
        content: "";
        position: absolute;
        top: -10px;
        left: -10px;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        border: 10px solid transparent;
        border-top-color: #45adee;
    }

    #loader-1:before {
        z-index: 100;
        animation: spin 1s infinite;
    }

    #loader-1:after {
        border: 10px solid #ccc;
    }

    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .text-center {
        text-align: center;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        position: relative;

        border: 1px solid #ccc;
        padding: 12px;
        padding-top: 20px;
        padding-bottom: 50px;
        margin: 60px auto;
        border-radius: 2px;
        width: 480px;
        height: auto;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
        background: #fff url('assets/digiwallet_logo.svg') no-repeat bottom left;
        background-size: 80px;
        @media (max-width: 768px) {
            width: 100%;
        }
    }

    .vue-pincode-input-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;

        .vue-pincode-input {
            width: 40px;
            height: 36px;

            outline: 0;
            margin: 3px;
            padding: 5px;
            max-width: 40px;
            text-align: center;
            font-size: 1.1rem;
            border: none;
            border-radius: 3px;
            box-shadow: 0 0 3px rgba(0, 0, 0, .5);
        }
    }


</style>
